(function () {
  'use strict';

  var KLAVIYO_BACK_IN_STOCK_URL =
    'https://a.klaviyo.com/client/back-in-stock-subscriptions';
  /** @see https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription */
  var KLAVIYO_REVISION = '2025-10-15';

  var MSG_EMAIL = 'Please enter a valid email address.';
  var MSG_COMPANY_ID = 'Sign-up is unavailable right now.';
  var MSG_VARIANT = 'This item is unavailable right now. Please try again later.';
  var MSG_GENERIC = 'Something went wrong. Please try again later.';

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /**
   * Public company_id from the `klaviyo_company_id` theme setting.
   * @returns {string}
   */
  function getKlaviyoCompanyId() {
    return (window.liquidCustom && window.liquidCustom.klaviyoCompanyId || '').trim();
  }

  /**
   * @param {{email: string, variantId: string}} params
   * @returns {Promise<void>}
   */
  function subscribeToBackInStock(params) {
    var companyId = getKlaviyoCompanyId();
    if (!companyId) {
      return Promise.reject(new Error(MSG_COMPANY_ID));
    }

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email: params.email },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + params.variantId,
            },
          },
        },
      },
    };

    var url =
      KLAVIYO_BACK_IN_STOCK_URL + '?company_id=' + encodeURIComponent(companyId);

    return fetch(url, {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        accept: 'application/vnd.api+json',
        revision: KLAVIYO_REVISION,
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (res.ok || res.status === 202) return;

      return res
        .json()
        .catch(function () {
          return null;
        })
        .then(function (body) {
          var detail = body && body.errors && body.errors[0] && body.errors[0].detail;
          throw new Error(detail || MSG_GENERIC);
        });
    });
  }

  function showError(errorsEl, message) {
    errorsEl.textContent = message;
    errorsEl.classList.add('is-visible');
  }

  function clearError(errorsEl) {
    errorsEl.textContent = '';
    errorsEl.classList.remove('is-visible');
  }

  function initBackInStockPopup() {
    var modal = document.querySelector('mr-modal#back-in-stock-popup');
    if (!modal) return;

    var form = modal.querySelector('[data-bis-form]');
    var formState = modal.querySelector('[data-bis-form-state]');
    var successState = modal.querySelector('[data-bis-success]');
    var variantField = modal.querySelector('[data-bis-variant-id-field]');
    var emailField = modal.querySelector('[data-bis-email-field]');
    var submitBtn = modal.querySelector('[data-bis-submit]');
    var errorsEl = modal.querySelector('[data-bis-errors]');

    if (!form || !variantField || !emailField || !submitBtn || !errorsEl) {
      return;
    }

    function resetPopup() {
      form.reset();
      clearError(errorsEl);
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-loading');
      if (formState) formState.hidden = false;
      if (successState) successState.hidden = true;
    }

    // Delegated so it covers both the PDP and the Quick View popup (same markup).
    document.addEventListener('click', function (event) {
      var input = event.target.closest && event.target.closest('[data-sold-out]');
      if (!input) return;

      var variantId = input.getAttribute('data-bis-variant-id');
      if (!variantId) return;

      event.preventDefault();

      resetPopup();
      variantField.value = variantId;

      if (typeof modal.show === 'function') {
        modal.show();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearError(errorsEl);

      var variantId = variantField.value;
      if (!variantId) {
        showError(errorsEl, MSG_VARIANT);
        return;
      }

      var email = emailField.value.trim();
      if (!email || !EMAIL_PATTERN.test(email)) {
        showError(errorsEl, MSG_EMAIL);
        return;
      }

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');

      subscribeToBackInStock({ email: email, variantId: variantId })
        .then(function () {
          if (formState) formState.hidden = true;
          if (successState) successState.hidden = false;
        })
        .catch(function (err) {
          console.error('[klaviyo-back-in-stock]', err);
          showError(errorsEl, err && err.message ? err.message : MSG_GENERIC);
        })
        .finally(function () {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
        });
    });
  }

  if (customElements.get('mr-modal')) {
    initBackInStockPopup();
  } else {
    customElements.whenDefined('mr-modal').then(initBackInStockPopup);
  }
})();
